import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fileUrl } from "../lib/api";

export default function Messages() {
  const [convs, setConvs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/messages/conversations");
      setConvs(data);
    } catch (err) {
      console.error("conversations load failed", err);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="min-h-[100dvh] bg-ink pb-32 px-5 pt-8">
      <p className="text-papaya text-[10px] tracking-[0.3em] uppercase font-bold">Inbox</p>
      <h1 className="text-cream text-4xl font-black tracking-tighter mt-1">Messages</h1>

      <div className="mt-6 space-y-2" data-testid="conversation-list">
        {loading && <p className="text-cream/40 text-sm">Loading…</p>}
        {!loading && convs.length === 0 && (
          <p className="text-cream/50 text-sm">No conversations yet. Visit a profile and tap message to say hi.</p>
        )}
        {convs.map((m) => (
          <Link
            key={m.peer?.id}
            to={`/messages/${m.peer?.id}`}
            data-testid={`conv-${m.peer?.username}`}
            className="flex items-center gap-3 p-3 rounded-2xl bg-white/5 border border-white/5 hover:border-papaya/40 transition-colors"
          >
            <div className="w-12 h-12 rounded-full overflow-hidden bg-gradient-to-br from-papaya to-sea flex items-center justify-center text-ink font-black flex-shrink-0">
              {m.peer?.avatar_path ? <img src={fileUrl(m.peer.avatar_path)} alt="" className="w-full h-full object-cover" /> : (m.peer?.display_name || "?")[0]?.toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-cream font-bold truncate">{m.peer?.display_name || m.peer?.username}</p>
              <p className="text-cream/50 text-sm truncate">{m.text || (m.voice_path ? "🎤 Voice clip" : m.media_path ? "📷 Media" : "")}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
